// extracted by mini-css-extract-plugin
export default {"root":"IGqQi","variant-horizontal":"_2m0Rr","variantHorizontal":"_2m0Rr","title":"QfXAg","message":"_3J7Eo","core-star":"_2i_1F","coreStar":"_2i_1F"};